//@flow
import Constants   from '../constants';
import Dispatcher  from '../dispatcher';

import type { PromotionSet, PromotionActivation } from '../Stores/Promotions/promotionsStoreClass';
import type { PromotionObject } from '../Stores/Promotions/promotionModel';

export default {
  setActivePromotion(data:PromotionSet) {
    Dispatcher.dispatchAction(Constants.SET_ACTIVE_PROMOTION, data);
  },

  addOrUpdatePromotion(data:PromotionObject) {
    Dispatcher.dispatchAction(Constants.ADD_OR_UPDATE_PROMOTION, data);
  },

  activatePromotion(data:PromotionObject) {
    Dispatcher.dispatchAction(Constants.ACTIVATE_PROMOTION, data);
  },

  activatePromotions(data:PromotionActivation) {
    Dispatcher.dispatchAction(Constants.ACTIVATE_PROMOTIONS, data);
  },
};
